import { EnvironmentInjector, inject, runInInjectionContext } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Auth, authState } from '@angular/fire/auth';
import { Firestore, doc, getDoc } from '@angular/fire/firestore';
import { from, of } from 'rxjs';
import { catchError, map, switchMap, take } from 'rxjs/operators';

export const adminGuard: CanActivateFn = (_route, state) => {
  const auth      = inject(Auth);
  const firestore = inject(Firestore);
  const router    = inject(Router);
  const injector  = inject(EnvironmentInjector);

  return authState(auth).pipe(
    take(1),
    switchMap(firebaseUser => {
      if (!firebaseUser) {
        return of(router.createUrlTree(['/login'], { queryParams: { returnUrl: state.url } }));
      }

      return from(firebaseUser.getIdTokenResult(true)).pipe(
        switchMap(tokenResult => {
          if (tokenResult.claims['admin'] === true) {
            return of(true as const);
          }

          const fetch = runInInjectionContext(injector, () =>
            getDoc(doc(firestore, 'users', firebaseUser.uid)),
          );
          return from(fetch).pipe(
            map(snap => {
              const role = snap.exists() ? snap.data()['role'] : null;
              return role === 'admin'
                ? true
                : router.createUrlTree(['/dashboard']);
            }),
          );
        }),
        catchError(() => of(router.createUrlTree(['/dashboard']))),
      );
    }),
  );
};
